<!--
  Copyright (c) 2019-2024 Bosch Rexroth AG
-->

<!-- <img [src]="about.imageSrc" style="height: auto; width: 100%;" alt=""> -->
<bci-page-content>
    <h2>{{'_AboutTitle'|translate}}</h2>
    <!-- <section *ngIf="about.productVersion || about.versionLink">
      {{'core.about.version'|translate}}: {{about.productVersion}} <span *ngIf="about.versionLink">&rarr; <a
          [routerLink]="about.versionLink.url">{{about.versionLink.text}}</a></span>
    </section> -->
    <section>
      <p>{{'_AboutCopyright'|translate}}</p>
      <p><a [href]="vendorLink" target="_blank">{{vendorLink}}</a></p>
      <p>
        <ng-container *ngFor="let line of vendorAddress; last as isLast">{{line}}<br *ngIf="!isLast" />
        </ng-container>
      </p>
    </section>
    <section>
      <h5>{{'_AboutMoreTitle'|translate}}</h5>
      <div actions>
        <button bciSecondaryButton (click)="onAboutFossClicked()">{{'_AboutLicenseInfoText'|translate}}</button>
        <button bciSecondaryButton (click)="onTermsOfUseClicked()">{{'_AboutTermsOfUseText'|translate}}</button> 
      </div>
    </section>
</bci-page-content>
